<app-message-list
  [guest]="guest"
  [messages]="emailMessages"
  [inquiry]="inquiry"
  [emptyTableType]="tableType"
  [hasMove]="false"
></app-message-list>
